module.exports = __webpack_public_path__ + "img/austria-colorectal-cancer-female.0fd98d3f.png";